<template>
  <div>

    <!-- 图片标题 -->
    <div class="">
      <div class="pannel-pay-title">
        <img src="/imgs/title_dev.jpg" />
      </div>
    </div>

    <!-- 订单号 -->
    <OrderIdComp :order-info="orderInfo" />

    <!-- 付款流程 -->
    <div class="pannel">
      <div class="pay-flow">
        <p style="color: #4CAF50;"><b>付款流程：</b></p>
        <p class="no">1、如果需要测试回调，点击<span style="color:red;">按钮</span>即可；</p>
        <p class="no">2、如果不需要回调，等待订单<span style="color:red;">结束</span>即可；</p>
        <p class="no">3、祝老板<span style="color:red;">财源滚滚，鸿运当头，风生水起</span>！</p>
      </div>
    </div>

    <!-- 倒计时 -->
    <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" />

    <!--按钮-->
    <div class="pannel-btn" v-if="orderInfo.orderId">
      <div style="padding-top:0.95em;padding-bottom:0.95em;">
        <input type="radio" id="huey1" value="0" v-model="typeAmount" @change="devChange" />
        <label for="huey1">支付全额</label>
        <input type="radio" id="huey2" value="1" v-model="typeAmount" style="margin-left:0.95em;" @change="devChange" />
        <label for="huey2">支付{{orderInfo.amount-1}}</label>
        <input type="radio" id="huey3" value="2" v-model="typeAmount" style="margin-left:0.95em;" @change="devChange" />
        <label for="huey3">支付{{orderInfo.amount+1}}</label>
      </div>
      <button class="btn btn-alip" style="width: 80%;" :disabled="ifSub" @click="devPayd">
        <span v-if="!ifSub">点此测试已支付</span>
        <span v-else>已提交测试请稍后</span>
      </button>
    </div>

    <!-- time tips -->
    <TimeTipsComp :order-info="orderInfo" />

    <!-- 警告事项 -->
    <div class="pannel-simp attention">
      <p class="">说明：<span style="color: red;">本通道为系统测试订单，不纳入记账体系</span>；点击按钮后，可测试回调</p>
    </div>

    <!--插槽-->
    <slot></slot>

  </div>

</template>

<script>
import * as apis from "@/apis/apis";
//
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
//
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      ifSub: false,
      typeAmount: 0,
    };
  },
  computed: {},
  created() {},
  methods: {
    devChange() {
      //复制1
      this.$parent.$parent.copySome(
        "test",
        1,
        () => {},
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 测试已支付
    devPayd() {
      this.ifSub = true;
      apis
        .devPayd({
          id: this.orderInfo.orderId,
          type: this.typeAmount,
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
      //复制2
      this.$parent.$parent.copySome(
        "test",
        2,
        () => {},
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
</style>
